import assert from '@/sui/tools/assert'
import { flattenSheetFromJSTree, convert, strIndex } from '@/sui/data/flatten/tools'

import { findSurveillance, sheetStatus } from '@/sui/data/flatten/common'

function initializeBadiCauseSheet (s, p, keySet) {
  const result = {}
  const notInTreeFields = [
    { key: 'module', r: 'BADICAUSE' },
    { key: 'surv_id', r: p.sv },
    { key: 'etb_finess', r: s.etb_finess },
    { key: 'etb_region', r: s.etb_region },
    { key: 'etb_nom', r: s.etb_name },
    { key: 'etb_statut', r: s.etb_status },
    { key: 'etb_type', r: s.etb_type },
    { key: 'fiche_id', r: p.id },
    { key: 'fiche_version', r: p.v },
    { key: 'fiche_état', r: sheetStatus(p.st) }
  ]

  for (let i = 0; i < notInTreeFields.length; i++) {
    const item = notInTreeFields[i]
    const key = `_${strIndex(i)}_${item.key}`
    result[key] = item.r
    keySet.add(key)
  }

  return {
    result: result,
    initCount: notInTreeFields.length
  }
}

const reducer = (tree) => (result, p) => {
  const s = findSurveillance(result, p)
  if (result.keys == null) {
    result.keys = []
  }

  result.r[result.i++] = flattenSheetFromJSTree(
    initializeBadiCauseSheet, tree, p, s, result.all
  )

  return result
}

function flatten2026 () {
  return (params) => {
    const m = params.type
    const sheets = params.sheets
    const tree = params.treeFields

    assert(m === 'badiCause')
    assert(sheets.length !== 0)
    assert(tree != null)

    return convert(params, reducer(tree), ['all'])
  }
}

export default {
  '2026': flatten2026()
}
